// Persistence
import { getMobileBoardPageAppearanceLocalStorage } from './mobileSettingsService';

// Constants
import { BoardPageAppearance, SetMobileSettingAction, SET_MOBILE_SETTING } from './mobileSettingsConstants';

// Types
import { UnknownAction } from 'redux';

type MobileSettings = {
    boardPageAppearance: BoardPageAppearance;
};

// FIXME-MOBILE Ionic initialisation?
const getInitialState = (): MobileSettings => {
    if (typeof screen === 'undefined') {
        return {
            boardPageAppearance: BoardPageAppearance.list,
        };
    }

    const boardPageAppearance = getMobileBoardPageAppearanceLocalStorage() as BoardPageAppearance;

    return {
        boardPageAppearance: boardPageAppearance || BoardPageAppearance.list,
    };
};

const handleSetMobileSetting = (state: MobileSettings, action: SetMobileSettingAction) => {
    return {
        ...state,
        [action.setting]: action.value,
    };
};

const initialState = getInitialState();

export default (state = initialState, action: UnknownAction) => {
    switch (action.type) {
        case SET_MOBILE_SETTING:
            return handleSetMobileSetting(state, action as SetMobileSettingAction);
        default:
            return state;
    }
};
